/**
 * initClarkerOverlayModule does exactly that, initializes the clarker overlay
 * module. It needed to be set up this way to work in both dev mode and in
 * compiled js because of google dependency complications.
 *
 * It takes no parameters and returns nothing.
 */
window.initClarkerOverlayModule = function () {
  /**
   * Constructor
   *
   * Creates an overlay on top of clustered (Clarker enabled) maps and places a
   * faux marker on top of the cluster. It's not a real marker but an image of a
   * marker that acts like a marker. Clusters and markers are on the same level
   * normally so you can't put markers on top of Clarker (usually) so this is a
   * workaround by faking a marker with an image.
   *
   * @param  {object} map    A google map instance
   * @param  {object} marker A google marker instance
   */
  function ClarkerMarkerOverlay(map, marker) {
    var self = this;
    this.marker = marker;
    this.markerLayer = $("<div />").addClass("overlay");
    this.setMap(map);
    this.$point = null;
    this.projection = this.getProjection();

    // missing projections fix, stash on map idle
    // https://stackoverflow.com/questions/3710745/google-maps-v3-overlayview-getprojection
    google.maps.event.addListener(map, "idle", function () {
      // stash overlay projection
      self.projection = self.getProjection();
    });
  }

  ClarkerMarkerOverlay.prototype = new google.maps.OverlayView();

  ClarkerMarkerOverlay.prototype.onAdd = function () {
    // Pane 6, one higher than the Clarker pane
    var $pane = $(this.getPanes().floatPane);
    $pane.append(this.markerLayer);
  };

  ClarkerMarkerOverlay.prototype.onRemove = function () {
    this.markerLayer.remove();
  };

  ClarkerMarkerOverlay.prototype.draw = function () {
    if (!this.marker) return;
    var fragment = document.createDocumentFragment();

    this.markerLayer.empty(); // Empty any previous rendered markers
    var icon = this.marker.activeIcon || this.marker.icon;
    var location = this.projection.fromLatLngToDivPixel(this.marker.position);

    // How much bigger than normal we want the icon
    var scale = 1.5;

    var iconShape = window.batchGeoGoogleMapsManager.settings.markersData.shape;
    var iconWidth = this.marker.icon.scaledSize.width * scale;
    var iconHeight = this.marker.icon.scaledSize.height * scale;

    // The +5/-2 here is to give some offset from the little right arrow on top
    // of the infobox and the markers below them that we're covering up
    var marginTop = iconShape == "circle" ? iconHeight / 2 + 5 : iconHeight - 2;

    var offset_x = 0,
      offset_y = 0;
    if (iconShape == "circle") {
      offset_x = -16;
      offset_y = -16;
    }

    var $point = $(
      '<div class="map-point" style="' +
        "width:32px; height:32px; " +
        "left:" +
        (location.x + offset_x) +
        "px; top:" +
        (location.y + offset_y) +
        "px; " +
        "position:absolute; cursor:grab;" +
        '">' +
        '<div style="' +
        "top:-" +
        marginTop +
        "px;" +
        "left:-" +
        iconWidth / 2 +
        "px;" +
        "height:" +
        iconHeight +
        "px;" +
        "width:" +
        iconWidth +
        "px;" +
        "position: relative;" +
        'overflow: hidden">' +
        '<img src="' +
        icon.url.replace(/"/g, "'") +
        '" width="100%">' +
        "</div>" +
        "</div>",
    );

    fragment.appendChild($point.get(0));
    this.markerLayer.append(fragment);
  };

  ClarkerMarkerOverlay.prototype.destroy = function () {
    this.setMap(null);
    this.markerLayer.remove();
  };

  window.ClarkerMarkerOverlay = ClarkerMarkerOverlay;
};
